import React from 'react';

export default function StatCard({ icon, label, value, color = '#00e676' }) {
  return (
    <div className="stat-card">
      <div className="d-flex align-items-center gap-2 mb-1">
        <i className={`bi ${icon}`} style={{ fontSize: 20, color }}></i>
        <span className="label">{label}</span>
      </div>
      <div className="value" style={{ color }}>{value}</div>
    </div>
  );
}
